import { useState, useCallback } from 'react'

export const useReferralAutoMatch = ({
  insuranceCompanies = [],
  referralSourceList = [],
  setFormInputValues,
  referralSourceCode = null
}) => {
  const [autoMatchedReferral, setAutoMatchedReferral] = useState(null)
  const [showReferralField, setShowReferralField] = useState(!!referralSourceCode)

  const matchReferral = useCallback(
    (insuranceCompanyId) => {
      const selectedInsurance = insuranceCompanies.find((c) => c.id === insuranceCompanyId)

      const matchedReferral = referralSourceList.find((r) => r.value?.toLowerCase() === selectedInsurance?.name?.toLowerCase())

      if (matchedReferral) {
        setAutoMatchedReferral(matchedReferral)
        // setShowReferralField(true)
        setFormInputValues((prev) => ({
          ...prev,
          referral_source_code: matchedReferral.id
        }))
      } else {
        setAutoMatchedReferral(null)
        setFormInputValues((prev) => ({
          ...prev,
          referral_source_code: null
        }))
      }
    },
    [insuranceCompanies, referralSourceList, setFormInputValues]
  )

  return {
    autoMatchedReferral,
    setAutoMatchedReferral,
    showReferralField,
    setShowReferralField,
    matchReferral
  }
}
